export default "__VITE_ASSET__2b6260d1__"